/**
 * 智能反馈提示 主控 详细显示逻辑参见原型的表格
 * 测试链接: http://0.0.0.0:8081/?env=classwork&template_project_id=230558&work_type=xes_classwork&needShare=false&stuId=57458&stuName=%E6%AD%A6%E4%BA%9A%E6%95%8F&stuGrade=6&goldNum=2&time=180&classId=33918&testId=[{%22109467%22:[%2233%22,%22139488%22]}]&liveId=475595&teamId=1&isPlayBack=0&urlKey=d79db9218caafdcb66beb4a80170249e
 * 原型文档: https://org.modao.cc/app/bdf035784897fe93cda29a89be22e1c2#screen=s1FAF77CA621557370880080
 */

import httpApi from '../../http'
import { getEnv, Environment } from './xes'
import { sendIntelligentPromptTrigger, extendworkTrigger } from './log'
import { getQuery } from '../xes/xes-lib'

class SmartCtrl {
    constructor(parTimeAll, parTemplateProjectId) {
        // super()
        this.env = getEnv()
        this.isSupportEnv =  [Environment.CLASSWORK, Environment.BAIZE].includes(this.env) ? true : false
        this.isSupportSmart =  [Environment.CLASSWORK].includes(this.env) ? true : false

        this.templateProjectId = parTemplateProjectId
        this.check = {
            clickTimes: 0,  // 点击检查次数
            errorTimes: 0   // 点击检查错误次数
        }
        this.checkTimes = 0
        this.earlyCheckSecond = 60 // 初期检测时间
        this.lateCheckSecond = parTimeAll ? parTimeAll * 0.7 : 120 // 后期检测时间 120 是测试写死的
        // this.lateCheckSecond = 20 // 后期检测时间 120 是测试写死的
        this.detectionTimer = {
            initial:null,
            later:null
        }
        this.timeAll = parTimeAll
        this.startTime = Date.now()// 记录初始时间

        // type Problem solving / Knowledge / check result
        // this.funcShowPromptMessageCallBack = function(
        //     showSubmit,
        //     showProblemSolving,
        //     showKnowlege,
        //     isActive,
        //     isEarly,
        //     isBlank
        // ) {
        //     console.log(
        //         '是否显示检查结果,是否显示解题思路,是否显示知识点',
        //         showSubmit,
        //         showProblemSolving,
        //         showKnowlege,
        //         isEarly,
        //         isBlank
        //     )
        // }

        this.funcHideAllCallBack = function(){

        }
        // initCode, funcGetCode
        this.initCode = null // 初始化代码
        this.funcGetCode = null // 获取代码的回调

        this.funcCheck = null // 检测函数
        // console.log('Create SmartCtrl Instance!')

        this.knowledgePoint = null      // 知识点
        this.solvingProblem = null      // 解题思路
        this.answerAnalysis = null      // 解题思路(附加题)
        this.detectionStatus = ''       // 前期 和后期
 
        this.init()
    }

    /* 初始化 */
    init() {
        if (!this.isSupportSmart) return
        console.log('欢迎使用智能反馈系统')
        /* 未设置倒计时，则不进行初/后期检测 */
        if (this.timeAll > 0 ){
            this.setupTimingDetection()
        }else{
            console.log('没有开启定时提示！')
        }
        /* 获取【解题思路】【知识点】【附加题-解题思路】 */
        httpApi
            .getIntelligentPrompt(this.templateProjectId)
            .then(res => {
                if (res && res.knowledge_point) {
                    this.knowledgePoint = res.knowledge_point
                }
                if (res && res.solving_problem) {
                    this.solvingProblem = res.solving_problem
                }
                if (res && res.answer_analysis) {
                    this.answerAnalysis = res.answer_analysis
                }
            })
            .catch(res => {
                console.error('错误获取解析和知识点提示', res)
            })
    }

    hideAllWindow() {
        this.funcHideAllCallBack()
    }
    showCtrlHeader(){
        this.funcShowCtrlHeader()
    }
    showNextProjectTips(){
        this.funcShowNextProjectTips()
    }
    showNextProject(type,goldNum,surplusTime,submitTime){
        this.funcShowNextProject(type,goldNum,surplusTime,submitTime)
        if(type === 'default'){
            /* 打点3.0 触发编程宝盒 */
            let duration = (Date.now() - this.startTime)/1000
            extendworkTrigger('trigger_box',duration)
        }
    }
    /**
     * 提交设置 提交时主动调取
     * @param {*} isBlank 是否是空白
     * @param {*} isCheckError 是否有错误
     */
    setSubmit(data) {
        if (!this.isSupportEnv) return
        data = data && data.data ? data.data.data : {}
        let isBlank = false
        let isCheckError = false
        let duration = (Date.now() - this.startTime)/1000
        if (data.result === 'fail') {
            isCheckError = true
            if (data.data.fail_index === 'no_changes') {
                // 如果空白显示
                isBlank = true
            }
        }

        if (isBlank) {
            this.funcShowPromptMessageCallBack(
                true,
                true,
                true,
                true,
                false,
                true
            );
            /* 打点3.0 提交 空白 */
            sendIntelligentPromptTrigger(
                "no_changes",
                "click_submit",
                duration,
                1
            )
        } else if (isCheckError) {
            this.funcShowPromptMessageCallBack(
                true,
                true,
                true,
                true,
                false,
                false
            );
            /* 打点3.0 提交 错误 */
            sendIntelligentPromptTrigger(
                "fail",
                "click_submit",
                duration,
                0
            )
        } else{
            /* 打点3.0 提交 正确 */
            sendIntelligentPromptTrigger(
                "success",
                "click_submit",
                duration,
                0
            )
        }
    }
    /**
     * 检测状态设置 - 检查时主动调起
     * @param {*} isCheckError 是的检测发现错误
     */
    setCheck(data) {
        if (!this.isSupportEnv) return
        data = data && data.data ? data.data.data : {}
        let isBlank = false
        let isCheckError = true
        let duration = (Date.now() - this.startTime)/1000
        if (data.result === 'success') {
            isCheckError = false
        } else {
            if (data.result === 'fail') {
                isCheckError = true
                if (data.data.fail_index === 'no_changes') {
                    // 如果空白显示
                    isBlank = true
                }
            }
        }

        this.check.clickTimes++
        this.check.errorTimes = this.check.errorTimes + (isCheckError ? 1 : 0)
        if (this.check.clickTimes === 3 && this.check.errorTimes === 3) {
            console.log('三次检测')
            if (isBlank) {
                this.funcShowPromptMessageCallBack(
                    false,
                    true,
                    true,
                    true,
                    false,
                    isBlank
                )
                /* 打点3.0  三次检测 空白*/
                sendIntelligentPromptTrigger(
                    "no_changes",
                    "triple_check",
                    duration,
                    1
                )
            } else {
                this.funcShowPromptMessageCallBack(
                    false,
                    true,
                    true,
                    true,
                    false,
                    isBlank
                )
                /* 打点3.0 三次检测 错误 */
                sendIntelligentPromptTrigger(
                    "fail",
                    "triple_check",
                    duration,
                    0
                )
            }
            
            // 主动 - 提交知识点和解题思路
            // this.funcShowPromptMessageCallBack(false, true, true,false,false,true)
            // 主动 - 提交知识点和解题思路
            // this.funcShowPromptMessageCallBack(true, true, true,true,true,true)
            // 主动 - 知识点和解题思路
            // this.funcShowPromptMessageCallBack(false, true, true,true,true,true)
            // 主动 - 都没有
            // this.funcShowPromptMessageCallBack(false, false, false,true,true,true)
            // 被动 - 都没有
            // this.funcShowPromptMessageCallBack(false, false, false,false,true,true)
            // 初期 空白 - 锦囊 - 解题思路
            // this.funcShowPromptMessageCallBack(false, true, true,false,true,true)
            // this.funcShowPromptMessageCallBack(false, true, true,true,false,isBlank)
            // 后期 空白 - 锦囊
            // this.funcShowPromptMessageCallBack(false, true, true,false,false,false)
        }
    }
    /**
     * 设置调起显示回调
     * @param {*} func 调起显示回调
     */
    setShowPromptMessageCallBack(func) {
        this.funcShowPromptMessageCallBack = func
    }

    setHideAllCallBack(func){
        this.funcHideAllCallBack = func
    }
    /* 显示控制头 */
    setShowCtrlHeader(func){
        this.funcShowCtrlHeader = func
    }
    /* 显示附加题提示气泡 */
    setShowNextProjectTips(func){
        this.funcShowNextProjectTips = func
    }
    /* 显示附加题宝盒 */
    setShowNextProject(func){
        this.funcShowNextProject = func
    }
    /* 关闭定时检测 */
    closeTimingDetection(){
        clearTimeout(this.detectionTimer.initial)
        clearTimeout(this.detectionTimer.later)
    }
    /**
     * 初始化后自动调起 - 定时检测
     */
    setupTimingDetection() {
        // 初期检测
        this.detectionTimer.initial = setTimeout(() => {
            console.log('触发初期检测')
            this.detectionStatus = '初期'
            this.checkBlank()
        }, this.earlyCheckSecond * 1000)
        // 后期检测
        this.detectionTimer.later = setTimeout(() => {
            console.log('后期检测')
            this.detectionStatus = '后期'
            this.checkBlank()
        }, this.lateCheckSecond * 1000)
    }

    doTimingDetection(data) {
        if (!this.isSupportSmart) return
        // 初期检测
        data = data && data.data ? data.data : {}
        let duration = (Date.now() - this.startTime)/1000
        if (data.result === 'fail' && this.detectionStatus === '初期') {
            console.log('初期检测', data)
            if (data.data.fail_index === "no_changes") {
                // 如果空白显示
                console.log("初期检测 - 代码没有变化");
                this.funcShowPromptMessageCallBack(
                    false,
                    true,
                    false,
                    false,
                    true,
                    true
                );
                /* 打点3.0 初期(空白) */
                sendIntelligentPromptTrigger(
                    "no_changes",
                    "initial",
                    duration,
                    1
                )
            } else {
                /* 打点3.0 初期(错误) */
                // sendIntelligentPromptTrigger(
                //     "fail",
                //     "initial",
                //     duration,
                //     0
                // )
            }
        }
        if (data.result === 'fail' && this.detectionStatus === '后期') {
            console.log('后期检测', data)
            if (data.data.fail_index === "no_changes") {
                // 如果空白显示
                console.log("后期检测 - 代码没有变化");
                this.funcShowPromptMessageCallBack(
                    false,
                    true,
                    false,
                    false,
                    false,
                    true
                );
                /* 打点3.0 后期(空白) */
                sendIntelligentPromptTrigger(
                    "no_changes",
                    "later",
                    duration,
                    1
                )
            } else {
                // 是否有错误
                console.log("后期检测 - 有错误");
                this.funcShowPromptMessageCallBack(
                    false,
                    true,
                    true,
                    false,
                    false,
                    false
                );
                /* 打点3.0 后期(错误) */
                sendIntelligentPromptTrigger(
                    "fail",
                    "later",
                    duration,
                    0
                )
            }
        }
    }
    /* --------------------C++/Python--------------------- */
    // /**
    //  * 设置初始化代码，和获取代码的回调
    //  * @param {*} initCode 初始化代码
    //  * @param {*} funcGetCode 获取代码
    //  */
    // setCode(initCode, funcGetCode) {
    //   this.initCode = initCode
    //   this.funcGetCode = funcGetCode
    // }
    /**
     * 设置回调 检测空白和检测
     * @param {*} funcCheck 设置检测回调
     */
    setCheckCallBack(funcCheck) {
        this.funcCheck = funcCheck
    }
    /**
     * 检测是否是空白
     */
    checkBlank() {
        if (this.funcCheck) {
            return this.funcCheck()
        }
    }
    /* ----------------------------------------------------- */
}

var time = Number(getQuery('time', -1))
var template_project_id = Number(getQuery('template_project_id', 1))

const smartCtrl = new SmartCtrl(time, template_project_id)

window.smartCtrl = smartCtrl

export default smartCtrl
